import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'signup_verify_identity.title',
  },
  subTitle: {
    id: 'signup_verify_identity.sub_title',
  },
  dropZoneText: {
    id: 'signup_verify_identity.drop_zone_text',
  },
  successfullyAdded: {
    id: 'toaster.successfully_added',
  },
  deleted: {
    id: 'toaster.deleted',
  },
});
